'use client';

import React, { useEffect, useState } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { Divider, Stack, Tab, Tabs } from '@mui/material';

interface TabItem {
  id: string;
  label: string;
  content: React.ReactNode;
}

interface TabSwitcherProps {
  tabList: TabItem[];
}

export function TabSwitcher({ tabList }: TabSwitcherProps): React.JSX.Element {
  const router = useRouter();
  const searchParams = useSearchParams();

  const currentTab = searchParams.get('tab') || tabList[0]?.id;
  const [tabValue, setTabValue] = useState(currentTab);

  useEffect(() => {
    setTabValue(currentTab);
  }, [currentTab]);

  const handleChange = (_: React.SyntheticEvent, newValue: string): void => {
    const params = new URLSearchParams(searchParams.toString());
    params.set('tab', newValue);
    router.push(`?${params.toString()}`);
  };

  return (
    <>
      <Tabs value={tabValue} onChange={handleChange}>
        {tabList.map((item) => (
          <Tab key={item.id} label={item.label} value={item.id} />
        ))}
      </Tabs>
      <Divider />
      {tabList.map((item) =>
        item.id === tabValue ? (
          <Stack sx={{ pt: 2 }} key={item.id}>
            {item.content}
          </Stack>
        ) : null
      )}
    </>
  );
}

export default TabSwitcher;
